import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { articles } from "@/mocks/articles";
import type { Article } from "@/mocks/articles";

const LANG_KEYS = ["en", "pl", "es", "fr"] as const;

export default function ArticlesSection() {
  const { t, i18n } = useTranslation();
  const lang = (LANG_KEYS.includes(i18n.language as (typeof LANG_KEYS)[number])
    ? i18n.language
    : "en") as (typeof LANG_KEYS)[number];

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6 lg:px-10">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
            {t("articles.title")}
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            {t("articles.subtitle")}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {articles.map((a: Article) => {
            const content = a[lang];
            const dateStr = new Date(a.updated).toLocaleDateString(lang, {
              year: "numeric",
              month: "short",
              day: "numeric",
            });
            return (
              <Link
                key={a.slug}
                to={`/article/${a.slug}`}
                className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-all hover:-translate-y-0.5 hover:border-primary-300"
              >
                <div className="flex items-center gap-2">
                  <span className="inline-flex items-center whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-semibold text-secondary-900">
                    {content.categoryLabel}
                  </span>
                  <span className="text-xs text-foreground-400">{content.readTime}</span>
                </div>
                <h3 className="mt-3 font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                  {content.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                  {content.intro}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-3">
                  <span className="text-xs text-foreground-400">{dateStr}</span>
                  <span className="flex items-center gap-1 text-xs font-semibold text-primary-600">
                    {t("articles.read")}
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}